import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  card: {
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '18px 8px 8px 8px',
      marginTop: -10,
      backgroundColor: theme.palette.common.white,
      borderBottomLeftRadius: theme.shape.borderRadius,
      borderBottomRightRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[1],
      transition: `box-shadow 250ms ${theme.transitions.easing.easeInOut}`,
    },

    '&:hover > div': {
      boxShadow: theme.shadows[3],
    },
  },
  cardMedia: {
    height: 122,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& img': {
      display: 'block',
      maxWidth: '100%',
      maxHeight: '100%',
    },
  },
  cardText: {
    flex: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '& a': {
      color: 'inherit',
      textDecoration: 'none !important',
    },
  },
}));
